import { render, staticRenderFns } from "./side-menu.vue?vue&type=template&id=bfed2150"
import script from "./side-menu.vue?vue&type=script&lang=js"
export * from "./side-menu.vue?vue&type=script&lang=js"
import style0 from "./side-menu.vue?vue&type=style&index=0&id=bfed2150&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfed2150')) {
      api.createRecord('bfed2150', component.options)
    } else {
      api.reload('bfed2150', component.options)
    }
    module.hot.accept("./side-menu.vue?vue&type=template&id=bfed2150", function () {
      api.rerender('bfed2150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/components/side-menu/side-menu.vue"
export default component.exports